import { Button, Input } from "@devhop/ui";
import { PackageIcon } from "lucide-react";
import { SimpleSelect } from "@/shared/ui/SimpleSelect";

/** Radix Select ບໍ່ອະນຸຍາດ value="" ສຳລັບ SelectItem */
const ALL_STATUS_VALUE = "__all__";
const STATUS_OPTIONS = [
  { value: ALL_STATUS_VALUE, label: "ທັງໝົດ" },
  { value: "active", label: "ໃຊ້ງານ" },
  { value: "hidden", label: "ເຊື່ອງ" },
];

type ShopProductsToolbarProps = {
  search: string;
  status: string;
  onSearchChange: (v: string) => void;
  onStatusChange: (v: string) => void;
  onAssignClick: () => void;
  canAssign: boolean;
};

export function ShopProductsToolbar({
  search,
  status,
  onSearchChange,
  onStatusChange,
  onAssignClick,
  canAssign,
}: ShopProductsToolbarProps) {
  return (
    <div className="flex flex-wrap items-center gap-3 px-4 pt-4">
      <Input
        placeholder="ຄົ້ນຫາ ຊື່ສິນຄ້າ, SKU, barcode..."
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        className="max-w-xs"
      />
      <SimpleSelect
        value={status === "" ? ALL_STATUS_VALUE : status}
        onValueChange={(v) => onStatusChange(v === ALL_STATUS_VALUE ? "" : v)}
        options={STATUS_OPTIONS}
        placeholder="ສະຖານະ"
        className="w-[140px]"
      />
      {canAssign && (
        <Button
          className="bg-[#F26522] hover:bg-[#F26522]/90"
          onClick={onAssignClick}
        >
          <PackageIcon className="size-4" />
          ມອບສິນຄ້າ
        </Button>
      )}
    </div>
  );
}
